import { Box, Stack, Typography } from "@mui/material";
import HtmlPreview, { ARTICLE_FONT_SCALE } from "@entrilia/shared/components/html/HtmlPreview";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import CategoryInlineTags from "../../../../common/CategoryInlineTags";
import InvestorCommunicationPortalPreviewNote from "../../InvestorCommunicationPortalPreviewNote";
import type { CommunicationImageSource } from "../investorCommunicationDetailsTypes";
import { getImageSourceKey } from "../investorCommunicationDetailsTypes";
import InvestorCommunicationHeroImage from "./InvestorCommunicationHeroImage";

interface Props {
  title?: string;
  categoryIds: string[];
  htmlBody?: string;
  heroImageSource?: CommunicationImageSource;
}

const heroImagePlaceholder = (
  <Box sx={{ display: "flex", width: "100%", aspectRatio: "3 / 2", bgcolor: "background.grey" }}>
    <InlineLoader />
  </Box>
);

const InvestorCommunicationContentPreview = ({ title, categoryIds, htmlBody, heroImageSource }: Props) => (
  <Stack spacing={2.5} sx={{ flex: 1, pt: 2.5 }}>
    <InvestorCommunicationPortalPreviewNote />

    {heroImageSource && (
      <InvestorCommunicationHeroImage
        key={getImageSourceKey(heroImageSource)}
        source={heroImageSource}
        sx={{ width: "100%", height: "auto" }}
        placeholder={heroImagePlaceholder}
      />
    )}

    <Typography variant="h2" sx={{ py: 1 }}>
      {title || "Untitled"}
    </Typography>

    {categoryIds.length > 0 && <CategoryInlineTags externalCategoryIds={categoryIds} />}

    {htmlBody && <HtmlPreview htmlContent={htmlBody} fontScale={ARTICLE_FONT_SCALE} />}
  </Stack>
);

export default InvestorCommunicationContentPreview;
